export const CONSTANTS = {
  EMPTY_STRING: '',
  CLOSE: 'close',
  STOP: 'stop',
  SETTING: 'setting',
  POPUP_CLASS: {
    END_SESSION: 'end-session-popup',
    MANAGE_SESSION: 'manage-session-room',
    LINK_SOCIAL_MEDIA: 'link-social-media',
    DELETE_SESSION: 'delete-session-popup',
    CREATE_SESSION: 'create-session-popup',
    INVOICE: 'invoice-popup'
  },
  POPUP_WIDTH: {
    PX_600: '600px',
    PX_750: '750px',
    PX_850: '850px',
    PX_500: '500px',
    PX_400: '400px'
  },
  MEDIA: {
    MIC: 'mic',
    CAM: 'cam',
  },
  NONE: 'none',
  DISPLAY_GUEST_NO: 3,
  HOME_PAGE: 'https://boomcaster.com/',
  WINDOW_10: 'Windows 10',
  WINDOW_11: 'Windows 11',
  WINDOWS: 'Windows',
  PLATFORMVERSION:'platformVersion',
  MAC_REFRESH_CMD: 'Command(⌘)-Shift-R',
  WINDOW_REFRESH_CMD: 'Cmd-Shift-F5'
}